module.exports = __webpack_public_path__ + "static/img/guide-32.f1ae7787.png";